module.exports = __webpack_public_path__ + "img/symmetry-success.ebe51265.svg";